import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import DisolveIcon from '../icons/DisolveIcon';
import DBAIcon from '../icons/DBAIcon';
import PencileIcon from '../icons/PencileIcon';

export const MainData = {
    heading: 'Services Dashboard',
};

export const TabList = [
    {
        label: 'Prime Offer Services',
        value: 1,
    },
    {
        label: 'Recommend Outsource Services',
        value: 2,
        status: 'Outsource',
    },
];

export const PrimeServiceData = [
    {
        id: 1,
        heading: 'Form a new entity',
        para: 'Form additional entities with ease! Our Business Advisors can guide you through forming additional entities with ease. Form additional entities with ease! Our Business Advisors can guide you through forming additional entities with ease. Form additional entities with ease! Our Business Advisors can guide you through forming additional entities with ease.',
        // btnIcon: <ArrowOutwardIcon />,
        // isCompleted: false,
        // icon: <FormIcon />,
        iconColor: '#91DC8B',
        buttonsList: [
            {
                name: 'Schedule Call',
            },
            {
                name: 'Buy Online',
            },
        ],
    },
    {
        id: 2,
        heading: 'Open Bank Account',
        para: 'Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.',
        // btnIcon: <ArrowOutwardIcon />,
        // isCompleted: false,
        // icon: <TaxIcon />,
        iconColor: '#E79344',
        buttonsList: [
            {
                name: 'Schedule Call',
            },
        ],
    },

    {
        id: 3,
        heading: 'Another Service',
        para: 'Cras justo odio, dapibus ac facilisis in, egestas eget quam.',
        // btnIcon: <ArrowOutwardIcon />,
        // isCompleted: false,
        // icon: <BusinessCreaditIcon />,
        iconColor: '#F82369',
        buttonsList: [
            {
                name: 'Instantly Apply',
            },
        ],
    },
];
export const RecommendServiceData = [
    {
        heading: 'Dissolve entity',
        para: "Expand your business horizons by forming a new entity. Whether you're branching out or launching a new venture, we’ll handle the paperwork to get you started.",
        btnIcon: <ArrowOutwardIcon />,
        // isCompleted: false,
        icon: <DisolveIcon />,
        iconColor: '#ED6262',
    },
    {
        heading: 'DBA',
        para: 'Simplify your tax season with expert tax preparation. Our professionals will ensure your returns are accurate and maximize your deductions.',
        btnIcon: <ArrowOutwardIcon />,
        // isCompleted: false,
        icon: <DBAIcon />,
        iconColor: '#FF8F05',
    },

    {
        heading: 'Amending',
        para: 'Build and enhance your business credit to secure better financing and growth opportunities. We’ll guide you through establishing a strong credit profile.',
        btnIcon: <ArrowOutwardIcon />,
        icon: <PencileIcon />,
        isCompleted: true,
        iconColor: '#C86F5C',
    },
];

// table
export const SERVICE_STATUS = {
    active: 'Active',
    paymentRequired: 'Payment Required',
    notfiled: 'Not Filed',
    suggested: 'Suggested',
};
export const TableHeadRowList = [
    { id: 'services', name: 'Services' },
    { id: 'company', name: 'Company' },
    { id: 'status', name: 'Status' },
    { id: 'primeContact', name: 'Payment Info' },
    { id: 'actions', name: 'Actions' },
];
export const TableBodyRowList = [
    {
        services: 'Entity Formation',
        company: 'Relay',
        status: SERVICE_STATUS.active,
        primeContact: ['Renews annually', 'Next: $144.53 on 5/4/2025'],
        actions: [
            {
                name: 'Update payment info',
            },
            {
                name: 'Manage service >',
            },
        ],
    },
    {
        services: 'Registered Agent',
        company: 'Good Bones Studio',
        status: SERVICE_STATUS.active,
        primeContact: ['Bills monthly, required with LLC', 'Next: $14.99 on 11/4/2025'],
        actions: [
            {
                name: 'Request support',
            },
            {
                name: 'Update payment info',
            },
        ],
    },
    {
        services: 'Registered Agent',
        company: 'Relay',
        status: SERVICE_STATUS.paymentRequired,
        primeContact: ['Bills monthly, required with LLC'],
        actions: [
            {
                name: 'Request support',
            },
            {
                name: 'Update payment info',
            },
        ],
    },
    {
        services: 'Tax Prepapartion',
        company: 'Apple Co.',
        status: SERVICE_STATUS.active,
        primeContact: ['Bills once, upon purchase'],
        actions: [
            {
                name: 'Request support',
            },
            {
                name: 'Incite portal >',
            },
        ],
    },
    {
        services: '2024 Beneficial Ownership Filing',
        company: 'Good Bones Studio',
        status: SERVICE_STATUS.suggested,
        primeContact: ['Included with entity formation'],
        actions: [
            {
                name: 'BOI portal >',
            },
        ],
    },
    {
        services: '2024 Beneficial Ownership Filing',
        company: 'Quantamp Studio',
        status: SERVICE_STATUS.notfiled,
        primeContact: ['Included with entity formation'],
        actions: [
            {
                name: 'BOI portal >',
            },
        ],
    },
];
